export default __webpack_public_path__ + "static/media/edit.4d426d28.svg";